import { SpaceView } from "containers/folders/hooks/utils";
import React from "react";
import { IFolderSelection } from "./folder-navigation";

export interface IFolderSelectionSettings {
    currentItemId: string;
    rootItemId: string;
    currentView: SpaceView;
    navigation: IFolderSelection[];
    itemSelected: IFolderSelection | IFolderSelection[];
    multiple: boolean;
    markAllAsSelected: boolean;
    automaticLoad: boolean;
}

export const getInitialSettings = (settings?: Partial<IFolderSelectionSettings>): IFolderSelectionSettings => ({
    currentItemId: settings?.currentItemId || null,
    rootItemId: settings?.rootItemId || null,
    currentView: settings?.currentView || null,
    navigation: settings?.navigation || [],
    itemSelected: settings?.itemSelected || null,
    multiple: !!settings?.multiple,
    markAllAsSelected: !!settings?.markAllAsSelected,
    automaticLoad: !!settings?.automaticLoad,
});

export const useFolderSelection = (
    initialSettings?: Partial<IFolderSelectionSettings>
): [IFolderSelectionSettings, (settings?: Partial<IFolderSelectionSettings>) => void] => {
    const initial = React.useMemo(() => getInitialSettings(initialSettings), [initialSettings]);
    const [settings, setSettings] = React.useState<IFolderSelectionSettings>(initial);

    const setter = React.useCallback(
        (settings: Partial<IFolderSelectionSettings> = initial) =>
            setSettings((prevValue) => ({
                ...prevValue,
                ...settings,
            })),
        [initial]
    );

    return [settings, setter];
};
